export const visibleFor = [
  // { value: "Only Myself", label: "Only Myself" },
  { value: "Coaches Of My Gym", label: "Coaches Of My Gym" },
  { value: "Members Of My Gym", label: "Members Of My Gym" },
  { value: "Everyone In My Gym", label: "Everyone In My Gym" },
];

export const planFor = [
  { value: "breakfast", label: "Breakfast" },
  { value: "morning_snack", label: "Morning Snack" },
  { value: "lunch", label: "Lunch" },
  { value: "afternoon_snack", label: "Afternoon Snack" },
  { value: "dinner", label: "Dinner" },
  { value: "evening_snack", label: "Evening Snack" },
] as const;

export const mealTypes = [
  // made same for backend mapping according to enums
  { key: "breakfast", label: "Breakfast" },
  { key: "morning_snack", label: "Morning Snack" },
  { key: "lunch", label: "Lunch" },
  { key: "afternoon_snack", label: "Afternoon Snack" },
  { key: "dinner", label: "Dinner" },
  { key: "evening_snack", label: "Evening Snack" },
];
